export enum Role {
  CompanyAdministrator = 'CompanyAdministrator',
  Administrator = 'Administrator',
  User = 'User',
  Creator = 'Creator',
  Curator = 'Curator',
  Owner = 'Owner'
}
